import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import LocationsPage from "./components/locations/LocationsPage";
import LocationDetail from "./components/locations/LocationDetail";
import DataPage from "./components/data/DataPage";
import DevicesPage from "./components/devices/DevicesPage";
import DeviceDetail from "./components/devices/DeviceDetail";
import OntologyPage from "./components/data/OntologyPage";
import DocumentationPage from "./components/docs/DocumentationPage";
import StatusReportPage from "./components/status/StatusReportPage";
import "./styles/leaflet-overrides.css";

export default function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <Header />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Navigate to="/locations" replace />} />
            <Route path="/locations" element={<LocationsPage />} />
            <Route path="/location/:name" element={<LocationDetail />} />
            <Route path="/query-browser" element={<DataPage />} />
            <Route path="/devices" element={<DevicesPage />} />
            <Route path="/device/:id" element={<DeviceDetail />} />
            <Route path="/data/ontology/:variable" element={<OntologyPage />} />
            <Route path="/docs" element={<DocumentationPage />} />
            <Route path="/status-report" element={<StatusReportPage />} />
            <Route path="*" element={<div className="p-6">Not found</div>} />
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}